/**
 * Configuration for the app.
 */
const jobiqoAppConfig = require('./../src/jobiqo/config/app');
const R = require('ramda');

// Set true for app localized.
const defaultLocale = 'en';
const defaultRegion = 'eu';
const locales = ['en'];

const priceConfig = {
  CURRENCY_PLACEMENT: 'before',
  USE_SPACING: false,
};

module.exports = R.mergeDeepRight(jobiqoAppConfig, {
  // Insert config here. this will be deep merged with config from jobiqo. Arrays are not deep mergeable
  // so make sure to cover those with [...jobiqoCompanyConfig.public.SOME_KEY_THAT_IS_ARRAY, new_item ]
  public: {
    TURBOPACK_BUILD: true,
    SITENAME: 'The Job Network',
    SITE_DESCRIPTION:
      'Get career and job search advice, or search over 2 million jobs on the largest job network',
    DEFAULT_LOCALE: defaultLocale,
    DEFAULT_REGION: defaultRegion,
    LOCALES: locales,
    FRONTENDS: {
      default: 'pandologic',
      demo: 'demo',
      hrcom: 'hrcom',
      newsday: 'newsday',
      whigjobs: 'whigjobs',
      keenesentinel: 'keenesentinel',
      delmarvalife: 'delmarvalife',
      montereycountyweekly: 'montereycountyweekly',
      diversityandcareer: 'diversityandcareer',
      veteranjobmatch: 'veteranjobmatch',
      diversityworkmatch: 'diversityworkmatch',
      pstribune: 'pstribune',
      mediajobcenter: 'mediajobcenter',
      taosnews: 'taosnews',
      ledgertranscript: 'ledgertranscript',
      concordmonitor: 'concordmonitor',
      nytimes: 'nytimes',
      dhg: 'dhg',
      gr: 'gr',
      vn: 'vn',
      jo: 'jo',
      cbiz: 'cbiz',
      sj: 'sj',
      wattw: 'wattw',
      ahepa: 'ahepa',
      slc: 'slc',
      deserthealthnews: 'deserthealthnews',
      pagecooperative: 'pagecooperative',
      acp: 'acp',
    },
    SOCIAL_LINKS: {
      facebook: 'https://www.facebook.com/thejobnetworkcareer/',
      twitter: 'https://twitter.com/thejobnetwork?lang=en',
      linkedin: 'https://www.linkedin.com/company/the-job-network',
      instagram: 'https://www.instagram.com/thejobnetwork_com/?hl=en',
    },
    CUSTOM_FONTS: true,
    GA4_MEASUREMENT_IDS: ['G-04SBN34ERZ', 'G-W6QKXFPEMD'],
    NEWSLETTER_FEATURE_ACTIVE: true,
    EURO_VAT_SYSTEM: false,
    LINKEDIN_OAUTH_FEATURE_ACTIVE: true,
    FACEBOOK_OAUTH_FEATURE_ACTIVE: true,
    GOOGLE_OAUTH_FEATURE_ACTIVE: true,
    BLOG_FEATURE_ACTIVE: true,
    AUTOCOMPLETE_WIDGET_OPTIONS: {
      country: ['us', 'ca'],
      location: { lat: 40.73061, lng: -73.935242 },
      radius: 5000,
    },
    PRICE_CONFIG: priceConfig,
    THEME: {
      colors: {
        primary: '#97bd45',
      },
    },
    OG_IMAGE: '/static/logo.png',
  },
});
